<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='address-box'>

  @if (allowSelection()) {

    <div class='p-field col-12' [ngClass]="{'mb': !mapFloatRight}">
    <span class='search-box-wrapper'>
      <p-iconField iconPosition='left'>
        <p-inputIcon styleClass='fa-solid fa-magnifying-glass' />
        <input id='search-box' type='text' autocomplete='off' pInputText
               [(ngModel)]='ngModel' [disabled]='disabled' (click)='op.show($event)' [required]='required()'
               data-testid='location' placeholder="{{'address.search-box.label' | translate}} *"
               [ngStyle]="{'width': '100%'}" />
      </p-iconField>
      @if (showClear) {
        <button
          pButton class='p-button-rounded clear' icon='ui-icon-clear' [disabled]='disabled'
          type='button'
          (click)='clear()' data-testid="clear-btn"></button>
      }
    </span>
    </div>
  }
  <p-popover #op [showCloseIcon]='true' [style]="{width: '450px'}" [appendTo]="'body'" [autoZIndex]='true' (click)='$event.stopPropagation()'>

    <ng-template pTemplate="content">
      <div class='suggestions row' *ngIf='ngModel' wellKeepInScreen
           [ngStyle]="{width: ((searchLocal && localAddressSearchService) ? 225 : 0) +  (searchOnGoolge ? 225 : 0) + 'px'}">

        <div class='list-wrapper ' *ngIf='searchLocal && localAddressSearchService'
             [ngClass]="{'col-6' : searchOnGoolge, 'col-12' : !searchOnGoolge, 'first-list': searchOnGoolge}">
          <div class='pr-xs list'>
            <well-local-address-search
              [searchTerm]='ngModel'
              (addressSelect)='onAddressSelect($event, op); ' data-testid="local-address-search">
            </well-local-address-search>
          </div>
          <span class='list-footer'> {{ 'address.search-box.local' | translate }} </span>
        </div>


        <div class='list-wrapper' *ngIf='searchOnGoolge'
             [ngClass]="{'col-6' : (searchLocal && localAddressSearchService), 'col-12' : !(searchLocal && localAddressSearchService)}">
          <div class='pl-xs list' *ngIf='map()'>
            <well-google-address-search
              [searchTerm]='ngModel'
              [map]='map()'
              (addressSelect)='onAddressSelect($event, op)' data-testid="google-address-search">
            </well-google-address-search>
          </div>
          <span class='list-footer'> {{ 'address.search-box.google' | translate }} </span>
        </div>

      </div>
    </ng-template>
  </p-popover>

  <well-map-location-picker
    *ngIf='map()'
    [ngClass]="{'map-float-right' : mapFloatRight, 'display-none': !showMap}"
    [location]='(form.value.pointDTO && form.value.pointDTO.longitude && form.value.pointDTO.latitude) ? form.value.pointDTO : null'
    [height]="mapHeight ? (mapHeight + 'px') : (mapFloatRight ? '350px' : '200px')"
    [disabled]='disabled'
    (addressChanged)='onAddressSelect($event)'
    (locationChanged)='onLocationChanged($event)' data-testid="map-location-picker">

  </well-map-location-picker>

  <div class='col-12 pt color-danger' *ngIf='showMapDistanceError'>
    {{ 'address.error.pinDistanceTooLong' | translate }}
  </div>

</div>

@if (ngModel) {
  <div class='overlay' (click)='cleanNgModel()'></div>
}


